// Navbar appearance
const cgNavPlain = document.getElementById('nav-bg-plain');
const cgNavGradient = document.getElementById('nav-bg-gradient');
// console.log(cgNav);
var scrollFunc = function() {
  var y = window.scrollY;
  if (y >= 150) {
    if (cgNavGradient) {
      cgNavGradient.style.opacity = "0";
    }
    if (cgNavPlain) {
      cgNavPlain.style.opacity = "1";
    }
  }
  else {
    if (cgNavPlain) {
      cgNavPlain.style.opacity = "0";
    }
    if (cgNavGradient) {
      cgNavGradient.style.opacity = "1";
    }
  }
}
window.addEventListener("scroll", scrollFunc);

